import { render, staticRenderFns } from "./ScrapProducts.vue?vue&type=template&id=37e32589&scoped=true&"
import script from "./ScrapProducts.vue?vue&type=script&lang=js&"
export * from "./ScrapProducts.vue?vue&type=script&lang=js&"
import style0 from "./ScrapProducts.vue?vue&type=style&index=0&id=37e32589&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e32589",
  null
  
)

export default component.exports